import { buildComponent } from '#components'
import Swiper from 'swiper'
import { Navigation, Scrollbar } from 'swiper/modules'

import './homepage-reviews.css'

const HomepageReviews = buildComponent({
  name: 'homepage-reviews',
  onConnected(component) {
    const reviewsSliderEl = component.querySelector<HTMLElement>('[data-reviews-slider]')

    if (!reviewsSliderEl || reviewsSliderEl.classList.contains('swiper-initialized')) return

    new Swiper(reviewsSliderEl, {
      modules: [Navigation, Scrollbar],
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false
      },
      breakpoints: {
        750: {
          slidesPerView: 2
        },
        990: {
          slidesPerView: 4
        }
      }
    })
  }
})

// Don't forget to declare the element tag name
// this is helpful for TypeScript to recognize the element`
declare global {
  interface HTMLElementTagNameMap {
    'homepage-reviews': typeof HomepageReviews
  }
}
